module.exports = __webpack_public_path__ + "img/2021_IMG_3094.32cf667e.jpg";